import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import type { ImportAccountRow } from '../../shared/importAccountTypes';

const FORM_INPUT_BASE =
  'h-[28px] px-1.5 py-0 text-xs border rounded focus:outline-none focus:ring-1 focus:ring-blue-500 bg-white text-gray-900 box-border';

interface ImportAccountRowPartyInputProps {
  row: ImportAccountRow;
  onChange: (rowId: string, value: string) => void;
  onBlur: (rowId: string, value: string) => void;
  onFocus: (rowId: string) => void;
  onKeyDown: (rowId: string, value: string, e: React.KeyboardEvent<HTMLInputElement>) => void;
  onConfirmSuggested?: (rowId: string) => void;
}

const ImportAccountRowPartyInput: React.FC<ImportAccountRowPartyInputProps> = ({
  row,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  onConfirmSuggested,
}) => {
  const isValid = !!row.matchedPartyId && row.validatedRowPartyCode && !row.partyInputError;
  const borderClass = row.partyInputError
    ? 'border-red-500'
    : isValid
      ? 'border-green-600'
      : 'border-gray-300';
  const showConfirmSuggested = row.status === 'suggested' && !!onConfirmSuggested;

  return (
    <div className="min-w-[120px]">
      <div className="flex items-center gap-1">
        <input
          type="text"
          value={row.partyCodeInput}
          onChange={(e) => onChange(row.id, e.target.value)}
          onBlur={(e) => onBlur(row.id, e.target.value)}
          onFocus={() => onFocus(row.id)}
          onKeyDown={(e) => onKeyDown(row.id, row.partyCodeInput, e)}
          maxLength={50}
          placeholder="Party Code"
          className={`${FORM_INPUT_BASE} flex-1 min-w-[100px] max-w-[160px] ${borderClass}`}
        />
        {showConfirmSuggested && (
          <button
            type="button"
            title="Confirm suggested mapping"
            aria-label="Confirm suggested mapping"
            onClick={() => onConfirmSuggested(row.id)}
            className="shrink-0 p-0.5 rounded text-amber-700 hover:text-green-700 hover:bg-green-100 transition-colors"
          >
            <CheckCircleIcon className="h-4 w-4" />
          </button>
        )}
      </div>
      {row.partyInputError && (
        <div className="text-red-500 text-[10px] leading-tight mt-0.5">{row.partyInputError}</div>
      )}
    </div>
  );
};

export default ImportAccountRowPartyInput;
